import { colors } from '../primitives/colors';
const codeColors = {
    brackets: colors.pink[300],
    boostOperator: colors.orange[500],
    colon: colors.base.white,
    field: colors.gray[600],
    not: colors.orange[500],
    andOr: colors.pink[500],
    to: colors.gray[400],
    number: colors.green[400],
    operator: colors.orange[500],
    operatorFuzzy: colors.orange[500],
    string: colors.teal[400],
    values: colors.gray[100],
    wildcard: colors.gray[50],
};
export const darkThemeColors = {
    surface: {
        default: colors.gray[950],
        defaultAlt: colors.gray[900],
        subtle: colors.gray[950],
        elevated: colors.gray[800],
    },
    gradient: {
        radiant: {
            stop1: colors.blue[500],
            stop2: colors.pink[500],
            stop3: colors.yellow[500],
        },
        recommended: {
            stop1: colors.blue[500],
            stop2: colors.pink[500],
            stop3: colors.orange[500],
        },
    },
    text: {
        code: codeColors,
        brand: colors.brand[400],
        positive: colors.success[600],
        negative: colors.error[500],
        warning: colors.warning[500],
        information: colors.blue[500],
        basic: {
            primary: colors.gray[200],
            secondary: colors.gray[300],
            tertiary: colors.gray[200],
            placeholder: colors.gray[500],
            description: colors.gray[300],
            disabled: colors.gray[500],
            inverse: colors.base.white,
            onColor: colors.gray[800],
            onColorAlt: colors.gray[800],
        },
        link: {
            default: colors.brand[400],
            pressed: colors.brand[800],
            visited: colors.violet[500],
        },
    },
    code: codeColors,
    foreground: {
        default: colors.gray[300],
        subtle: colors.gray[400],
        preDefined: colors.gray[500],
        disabled: colors.gray[500],
        onColor: colors.blue[300],
        onColorAlt: colors.gray[300],
        inverse: colors.base.white,
        brand: colors.blue[400],
        positive: colors.success[400],
        warning: colors.warning[400],
        negative: colors.error[400],
        information: colors.blue[400],
        starred: colors.yellow[400],
        violet: colors.violet[400],
    },
    effects: {
        focusRing: colors.brand[500],
        focusRingError: colors.error[500],
        shadowColor: colors.gray[950],
    },
    border: {
        default: colors.gray[700],
        control: colors.gray[500],
        alt: colors.gray[600],
        subtle: colors.gray[800],
        strong: colors.gray[400],
        disabled: colors.gray[600],
        inverse: colors.base.white,
        inverseSubtle: colors.gray[500],
        focus: colors.brand[400],
        brand: colors.brand[500],
        success: colors.success[400],
        danger: colors.error[400],
        warning: colors.warning[400],
        information: colors.blue[400],
    },
    dataVis: {
        vis1: colors.brand[400],
        vis2: colors.orange[600],
        vis3: colors.pink[400],
        vis4: colors.violet[500],
        vis5: colors.blue[600],
        vis6: colors.green[500],
        vis7: colors.yellow[600],
        vis8: colors.teal[600],
        vis9: colors.green[300],
        vis10: colors.pink[600],
        vis11: colors.gray[400],
    },
    severity: {
        critical: colors.error[400],
        high: colors.error[300],
        medium: colors.warningSerious[300],
        low: colors.yellow[300],
        info: colors.blue[500],
        debug: colors.gray[600],
        missing: colors.violet[400],
    },
    component: {
        default: colors.gray[900],
        inverse: colors.gray[700],
        elevated: colors.gray[800],
        inverseSubtle: colors.gray[600],
        emphasized: colors.gray[800],
        hover: colors.gray[800],
        active: colors.gray[500],
        isSelected: colors.brand[950],
        disabled: colors.gray[800],
        alt: {
            default: colors.gray[950],
            elevated: colors.gray[800],
            hover: colors.gray[700],
            active: colors.brand[800],
            isSelected: colors.brand[950],
        },
        bold: {
            default: colors.gray[600],
            hover: colors.gray[700],
            active: colors.gray[800],
        },
        brand: {
            default: colors.brand[600],
            hover: colors.brand[700],
            active: colors.brand[500],
        },
        brandLight: {
            default: colors.brand[950],
            hover: colors.brand[900],
            active: colors.brand[800],
        },
        negative: {
            default: colors.error[400],
            hover: colors.error[500],
            active: colors.error[600],
            isSelected: colors.error[300],
        },
        utility: {
            gray: {
                50: colors.gray[950],
                100: colors.gray[900],
                200: colors.gray[800],
                300: colors.gray[700],
                400: colors.gray[600],
                500: colors.gray[500],
                600: colors.gray[400],
                700: colors.gray[300],
            },
            yellow: {
                50: colors.yellow[950],
                100: colors.yellow[900],
                200: colors.yellow[800],
                300: colors.yellow[700],
                400: colors.yellow[600],
                500: colors.yellow[500],
                600: colors.yellow[400],
                700: colors.yellow[300],
            },
            green: {
                50: colors.green[950],
                100: colors.green[900],
                200: colors.green[800],
                300: colors.green[700],
                400: colors.green[600],
                500: colors.green[500],
                600: colors.green[400],
                700: colors.green[300],
            },
            orange: {
                50: colors.orange[950],
                100: colors.orange[900],
                200: colors.orange[800],
                300: colors.orange[700],
                400: colors.orange[600],
                500: colors.orange[500],
                600: colors.orange[400],
                700: colors.orange[300],
            },
            pink: {
                50: colors.pink[950],
                100: colors.pink[900],
                200: colors.pink[800],
                300: colors.pink[700],
                400: colors.pink[600],
                500: colors.pink[500],
                600: colors.pink[400],
                700: colors.pink[300],
            },
            red: {
                50: colors.error[950],
                100: colors.error[900],
                200: colors.error[800],
                300: colors.error[700],
                400: colors.error[600],
                500: colors.error[500],
                600: colors.error[400],
                700: colors.error[300],
            },
            indigo: {
                50: colors.indigo[950],
                100: colors.indigo[900],
                200: colors.indigo[800],
                300: colors.indigo[700],
                400: colors.indigo[600],
                500: colors.indigo[500],
                600: colors.indigo[400],
                700: colors.indigo[300],
            },
            violet: {
                50: colors.violet[950],
                100: colors.violet[900],
                200: colors.violet[800],
                300: colors.violet[700],
                400: colors.violet[600],
                500: colors.violet[500],
                600: colors.violet[400],
                700: colors.violet[300],
            },
            teal: {
                50: colors.teal[950],
                100: colors.teal[900],
                200: colors.teal[800],
                300: colors.teal[700],
                400: colors.teal[600],
                500: colors.teal[500],
                600: colors.teal[400],
                700: colors.teal[300],
            },
            blue: {
                50: colors.blue[950],
                100: colors.blue[900],
                200: colors.blue[800],
                300: colors.blue[700],
                400: colors.blue[600],
                500: colors.blue[500],
                600: colors.blue[400],
                700: colors.blue[300],
            },
        },
    },
    brandMarketing: {
        darkBlue: '#112031',
        neonYellow: '#FDFF37',
        middleBlue: '#004969',
        lightBlue: '#BBF0FF',
    },
};
//# sourceMappingURL=dark-colors.js.map